import toastr from 'toastr';

import * as actions from './actionsTypes';
import errorManage from '../../errorManage';
//import messages from '../../messages';
import surveyUserFormServices from './surveyUserForm.services';
import messages from '../../messages';


export const getSurveyUserForm = (params) => async (dispatch) => {
  dispatch({ type: actions.FETCH_SURVEY_USER_FORM_REQUEST, payload: true });
  try {
    const response = await surveyUserFormServices.getSurveyUserForm(params);
    const data = response.data;
    data.questions.sort((a, b) => a.secuence - b.secuence);
    data.questions.forEach(question => {
      if(question.answers){
        question.answers.sort((a, b) => a.questionSecuence - b.questionSecuence);
      }
    });
    dispatch({ type: actions.FETCH_SURVEY_USER_FORM_SUCCESS, payload: data });
  } catch (error) {
    errorManage(error, dispatch, actions.FETCH_SURVEY_USER_FORM_FAILURE);
  }finally{
    dispatch({ type: actions.FETCH_SURVEY_USER_FORM_REQUEST, payload: false });
  }
}

export const saveUseAnswers = (data, history) => async (dispatch) => {
  dispatch({ type: actions.SAVE_USER_ANSWERS_REQUEST, payload: true });
  try {
    await surveyUserFormServices.saveSurveyUserForm(data);
    //dispatch({ type: actions.SAVE_USER_ANSWERS_SUCCESS, payload: response.data });
    history.push(`/encuestas/complete`);	
  } catch (error) {
    errorManage(error, dispatch, actions.SAVE_USER_ANSWERS_FAILURE);
  }finally{
    dispatch({ type: actions.SAVE_USER_ANSWERS_REQUEST, payload: false });
  }
};

export const sendSurveyUserForm = (data) => async (dispatch) => {
  dispatch({ type: actions.SEND_SURVEY_USER_FORM, payload: true });
  try {
    await surveyUserFormServices.sendSurveyUserForm(data);
    toastr.success(messages.successMessage);
  } catch (error) {
    errorManage(error, dispatch, actions.SEND_SURVEY_USER_FORM_FAILD);
  }finally{
    dispatch({ type: actions.SEND_SURVEY_USER_FORM, payload: false });
  }
}